$(document).ready(function () {

    const ajaxPathGetInvoiceSelectHtml = '/action/report/invoice-basis';

    var modalParentElementInDOM = $('div#content');
    var modalTitle = '';
    var modalMessage = '';
    var modalButtonText = 'Lukk';
    var modalAlertType = '';

    activateToolTip('invoice_basis_wrapper', 'top');

    $('div#invoice_basis_wrapper input#invoice_basis_search_input').keyup(function (e) {
        var key = e.which;
        var searchInput = $('input#invoice_basis_search_input');
        // Refresh list if enter was pressed or the search field is empty
        if (key === 13 || searchInput.val() === '') {
            refreshCustomerList();
            hrefReset();
        }
    });

    $('div#invoice_basis_wrapper button#invoice_basis_search_button').click(function() {
        refreshCustomerList();
        hrefReset();
    });

    function refreshCustomerList() {
        let displayDeactivated = 0;

        if ($('input[name="display_deactivated_customers"]').is(':checked')) {
            displayDeactivated = 1;
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathGetInvoiceSelectHtml,
            data: {
                search_text: $('div#invoice_basis_wrapper input#invoice_basis_search_input').val(),
                display_deactivated: displayDeactivated
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#invoice_basis_wrapper select#invoice_customer_select').replaceWith(data.html);
        }).error(function (data) {
            console.log(data);
            modalTitle = 'Det oppstod en feil!';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        }).always(function (data) {

        });
    }

    function hrefReset() {
        $("a#generate_invoice_button").attr("href", "#");
    }

    $("div#invoice_basis_wrapper #generate_invoice_button").click(function() {

        let activeTab = $('.tab-content .tab-pane.active');
        let tabId = activeTab.attr('id');
        let invoice_customer = '';
        let dateFrom = $('#datofra').val();
        let dateTo = $('#datotil').val();
        let isMergeAllEqualProductsCheckboxChecked = false;

        if ($("div#invoice_basis_wrapper input#checkbox_merge_equal_products").is(':checked')) {
           isMergeAllEqualProductsCheckboxChecked = true;
        }

        if(tabId === 'all_customers') {
            invoice_customer = $('select#invoice_customer_select_all option:selected').val();
        }
        else if(tabId === 'search_for_customer') {
            invoice_customer = $('select#invoice_customer_select option:selected').val();
        }

        if(typeof invoice_customer === 'undefined') {
            modalTitle = 'Det oppstod en feil!';
            modalMessage = 'Du må velge en kunde for å generere PDF'
            modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
        }
        else {
            $("a#generate_invoice_button").attr("href", "/includes/report/classes/invoiceBasis/invoice.basis.report.pdf.php?from=" + dateFrom + "&to=" + dateTo + "&customer=" + invoice_customer + "&merge_equal_products=" + isMergeAllEqualProductsCheckboxChecked);
        }
    });
});